import { useQuery } from "@tanstack/react-query";
import { axios, APIBASE_REVIVERAPPLICATION } from "./ApiConfig";
import { CompaniesCountForTimePeriod, TotalSalesGraphPoint } from "@/types";

const getPeriodicTotalSales = async (
  startDate: string,
  endDate: string,
  numberOfPoints?: number,
  accumulate?: boolean
) =>
  axios.get(`${APIBASE_REVIVERAPPLICATION}api/graph/periodicTotalSales`, {
    params: {
      from: startDate,
      to: endDate,
      numberOfPoints: numberOfPoints,
      accumulate: accumulate,
    },
  });

export const useGetPeriodicSales = (
  startDate: string,
  endDate: string,
  periodicPoints?: number,
  accumulate?: boolean,
  options?: any
) => {
  const queryOptions = {
    refetchOnWindowFocus: false,
    ...options,
  };

  return useQuery<TotalSalesGraphPoint[] | undefined>({
    queryKey: ["getPeriodicTotalSales", startDate, endDate, periodicPoints, accumulate],
    queryFn: async () => {
      const result = await getPeriodicTotalSales(startDate, endDate, periodicPoints, accumulate);
      return result.data;
    },
    ...queryOptions,
  });
};

const getPeriodicTotalBuys = async (
  startDate: string,
  endDate: string,
  numberOfPoints?: number,
  accumulate?: boolean
) =>
  axios.get(`${APIBASE_REVIVERAPPLICATION}api/graph/periodicTotalBuys`, {
    params: {
      from: startDate,
      to: endDate,
      numberOfPoints: numberOfPoints,
      accumulate: accumulate,
    },
  });

export const useGetPeriodicBuys = (
  startDate: string,
  endDate: string,
  periodicPoints?: number,
  accumulate?: boolean,
  options?: any
) => {
  const queryOptions = {
    refetchOnWindowFocus: false,
    ...options,
  };

  return useQuery<TotalSalesGraphPoint[] | undefined>({
    queryKey: ["getPeriodicTotalBuys", startDate, endDate, periodicPoints, accumulate],
    queryFn: async () => {
      const result = await getPeriodicTotalBuys(startDate, endDate, periodicPoints, accumulate);
      return result.data;
    },
    ...queryOptions,
  });
};

const getPeriodicTotalTrade = async (startDate: string, endDate: string, numberOfPoints?: number) =>
  axios.get(`${APIBASE_REVIVERAPPLICATION}api/graph/periodicTotalTrade`, {
    params: {
      from: startDate,
      to: endDate,
      numberOfPoints: numberOfPoints,
    },
  });

export const useGetPeriodicTrade = (startDate: string, endDate: string, periodicPoints?: number, options?: any) => {
  const queryOptions = {
    refetchOnWindowFocus: false,
    ...options,
  };

  return useQuery<CompaniesCountForTimePeriod[] | undefined>({
    queryKey: ["getPeriodicTotalTrade", startDate, endDate, periodicPoints],
    queryFn: async () => {
      const result = await getPeriodicTotalTrade(startDate, endDate, periodicPoints);
      return result.data;
    },
    ...queryOptions,
  });
};
